import React from "react";
import { EMPTY_ARRAY } from "../../Components/misc";
import { useReactBlockPageFromRoute } from "../hooks";
import { LoadingIndicator } from "../LoadingIndicator";
import { Paragraph } from "../Paragraph";

export const ReactBlockPage: React.FC<{}> = ({ children }) => {
    const { data, loading } = useReactBlockPageFromRoute();

    const paragraphs = data?.result?.map(d => d.body)?.filter(d => d != null) ?? EMPTY_ARRAY;

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    {(loading || data === undefined) && <LoadingIndicator />}
                    {!loading &&
                        paragraphs.map((paragraph, index) => {
                            return (
                                <Paragraph
                                    key={index}
                                    nid={-1}
                                    status={true}
                                    title={undefined}
                                    adminId={"-1"}
                                    text={paragraph}
                                />
                            );
                        })}
                </div>
            </div>

            <div className="row">
                <div className="col-12">{children}</div>
            </div>
        </div>
    );
};
